module.exports = __webpack_public_path__ + "static/media/plus-icon.0b4034fb.svg";